import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


// function useLoggedIn() {
//     const navigate = useNavigate()
//     useEffect(() => {
//         const sess_user = JSON.parse(localStorage.getItem("sess_user"));
//         console.log(sess_user);
        
//         if(sess_user === null) {           
//             navigate('/login')
//         }
//     }, [])   
// }



export const clearStorageAndCookies = async () => {
    localStorage.clear();
    let a = window.location.href;
    let b: string;
    if (a.includes("localhost")) {
      b = "localhost";
    } else {
      let c = a.split("auth");
      b = c[0];
    }
    document.cookie = "JSESSIONID=; path=/auth; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
    document.cookie = `JSESSIONID=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    document.cookie = `JSESSIONID=;domain=${b}; expires=Thu, 01 Jan 1970 00:00:00 GMT;HttpOnly`;
  }



export const getPartnetId = async () => {
  const sess_user_data = localStorage.getItem("sess_user");
  if(sess_user_data) {
    const sess_user = JSON.parse(sess_user_data);
    const partner_id = sess_user?.user?.userId;
    return partner_id;
  } 
  return "";
}


export const getUserPriority = async () => {
  const sess_user_data = localStorage.getItem("sess_user");
  if(sess_user_data) {
    const sess_user = JSON.parse(sess_user_data);
    const priority = sess_user?.userProfile?.priority;
    return priority;
  } 
  return "";
}


// export const getEnterpriseId = async () => {
//   const sess_user_data = localStorage.getItem("sess_user");
//   if(sess_user_data) {
//     const sess_user = JSON.parse(sess_user_data);
//     const enterprise_id = sess_user?.user?.userId;
//     return enterprise_id;
//   } 
//   return "";
// }



//export default clearStorageAndCookies